"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _classnames6 = _interopRequireDefault(require("classnames"));
var _StyledInfoBox = _interopRequireWildcard(require("./StyledInfoBox"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var InfoBox = /*#__PURE__*/function (_React$Component) {
  function InfoBox() {
    var _this;
    (0, _classCallCheck2.default)(this, InfoBox);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, InfoBox, [].concat(args));
    (0, _defineProperty2.default)(_this, "handleCloseIcon", function (event) {
      var _this$props = _this.props,
        onClose = _this$props.onClose,
        type = _this$props.type;
      if (typeof type === 'string' && type !== 'default') {
        if (onClose) {
          onClose();
        }
      }
    });
    return _this;
  }
  (0, _inherits2.default)(InfoBox, _React$Component);
  return (0, _createClass2.default)(InfoBox, [{
    key: "renderBox",
    value: function renderBox() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        prefix = _this$props2.prefix,
        suffix = _this$props2.suffix,
        type = _this$props2.type,
        className = _this$props2.className,
        borderedPrefix = _this$props2.borderedPrefix,
        onClose = _this$props2.onClose,
        prefixCls = _this$props2.prefixCls,
        bordered = _this$props2.bordered,
        lineIcon = _this$props2.lineIcon,
        id = _this$props2.id;
      var prefixElement;
      var suffixElement;
      var iconName;
      if (!lineIcon) {
        if (type === 'success') {
          iconName = 'check-circle';
        } else if (type === 'danger') {
          iconName = 'close-circle';
        } else if (type === 'warning') {
          iconName = 'warning-circle';
        } else if (type === 'info') {
          iconName = 'info-circle';
        } else {
          iconName = type;
        }
      } else {
        if (type === 'success') {
          iconName = 'success';
        } else if (type === 'danger') {
          iconName = 'error';
        } else if (type === 'warning') {
          iconName = 'warning';
        } else if (type === 'info') {
          iconName = 'info';
        } else {
          iconName = type;
        }
      }
      var cls = (0, _classnames6.default)(prefixCls, className);
      var styledInfoBoxPrefixCls = (0, _classnames6.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-prefix"), !!prefixCls), 'bordered', borderedPrefix));
      var styledInfoBoxSuffixCls = (0, _classnames6.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-suffix"), !!prefixCls));
      var styledInfoBoxWrapper = (0, _classnames6.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-wrapper"), !!prefixCls));
      var styledInfoBoxContainer = (0, _classnames6.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-container"), !!prefixCls));
      var styledInfoBoxContent = (0, _classnames6.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-content"), !!prefixCls));
      if (typeof type === 'string' && type !== 'default') {
        prefixElement = /*#__PURE__*/_react.default.createElement(_StyledInfoBox.StyledInfoBoxPrefix, {
          className: styledInfoBoxPrefixCls
        }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: iconName
        }));
      } else {
        prefixElement = prefix ? /*#__PURE__*/_react.default.createElement(_StyledInfoBox.StyledInfoBoxPrefix, {
          className: styledInfoBoxPrefixCls
        }, prefix) : null;
      }
      if (typeof type === 'string' && type !== 'default' && onClose) {
        suffixElement = /*#__PURE__*/_react.default.createElement(_StyledInfoBox.StyledInfoBoxSuffix, {
          onClick: this.handleCloseIcon,
          className: styledInfoBoxSuffixCls
        }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: "close"
        }));
      } else {
        suffixElement = suffix ? /*#__PURE__*/_react.default.createElement(_StyledInfoBox.StyledInfoBoxSuffix, {
          className: styledInfoBoxSuffixCls
        }, suffix) : null;
      }
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/_react.default.createElement(_StyledInfoBox.default, {
          id: id,
          theme: theme,
          type: type,
          className: cls,
          bordered: bordered
        }, /*#__PURE__*/_react.default.createElement(_StyledInfoBox.StyledInfoBoxWrapper, {
          className: styledInfoBoxWrapper
        }, prefixElement, /*#__PURE__*/_react.default.createElement(_StyledInfoBox.StyledInfoBoxContainer, {
          className: styledInfoBoxContainer
        }, /*#__PURE__*/_react.default.createElement(_StyledInfoBox.StyledInfoBoxContent, {
          className: styledInfoBoxContent
        }, children)), suffixElement));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderBox();
    }
  }]);
}(_react.default.Component);
InfoBox.propTypes = {
  type: _propTypes.default.oneOf(['default', 'info', 'success', 'warning', 'danger']),
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  prefix: _propTypes.default.object,
  borderedPrefix: _propTypes.default.bool,
  suffix: _propTypes.default.object,
  prefixCls: _propTypes.default.string,
  bordered: _propTypes.default.bool,
  lineIcon: _propTypes.default.bool
};
InfoBox.defaultProps = {
  type: 'default',
  className: '',
  prefixCls: '',
  bordered: false,
  lineIcon: false
};
var _default = exports.default = InfoBox;